import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { palette } from '../../theme/palette';
import Iconify from '../../theme/iconify/iconify';

import Model from '../chat/Model';
import Prompt from '../chat//Prompt';
import Message from '../chat/Message';
import { mislecAPI } from '../../util/axios';

function Chat({ }) {
    const [chat, setChat] = React.useState(null);
    const [model, setModel] = React.useState('Qwen');
    const [corpus, setCorpus] = React.useState(null);
    const [fetched, setFetched] = React.useState(false);
    const [prompt, setPrompt] = React.useState('');
    const [typing, setTyping] = React.useState(false);

    const { t } = useTranslation();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (chat) return;
        if (sessionStorage.getItem('mISLec_landing_chat')) {
            setChat(JSON.parse(sessionStorage.getItem('mISLec_landing_chat')));
            setTimeout(() => {
                scrollToBottom();
            }, 100);
        } else {
            setChat({});
        }
    }, [chat]);

    const sendMessage = () => {
        //  Timestamp
        const timestamp = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');

        //  Data preparation
        const data = {
            references: [],
            timestamp: chat.timestamp ? chat.timestamp : timestamp,
            last_modified: timestamp,
            messages: [
                ...(chat?.messages?.length > 0 ? chat.messages : []),
                {
                    role: 'USER',
                    text: prompt,
                    timestamp: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')
                }
            ]
        }
        setChat(data);
        setPrompt('');
        setTyping(true);
        scrollToBottom();

        //  Send data to the server
        mislecAPI.post('/api/chat/home', data)
            .then(res => {
                setTyping(false);
                setChat(res.data);
                sessionStorage.setItem('mISLec_landing_chat', JSON.stringify(res.data));
                scrollToBottom();
            })
            .catch(error => {
                setTyping(false);
            });
    }

    const scrollToBottom = () => {
        setTimeout(() => {
            const chatContainer = document.getElementById('mISLec_landing_chat_container');
            if (chatContainer) {
                chatContainer.scrollTop = chatContainer.scrollHeight + 16 + 16;
            }
        }, 100);
    }

    return (
        <>
            <Container
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    flex: 1,
                    mb: 0,
                    mt: 4
                }}
            >
                {chat?.messages ?
                    <Container id='mISLec_landing_chat_container' sx={{ mb: { xs: 0, md: 2 }, px: 0, overflowY: 'auto', scrollbarWidth: 'none' }}>
                        {chat &&
                            chat?.messages?.map((message, index) => (
                                <Message key={index} message={message} />
                            ))
                        }
                    </Container>
                    :
                    <Container
                        sx={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            px: 0
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 1,
                                width: { xs: '80%', md: '60%' },
                                textAlign: 'center',
                            }}
                        >
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Typography variant='h3'>{t('chat.new.title')}</Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Typography variant='body1'>
                                    {t('chat.new.start')} <b>{t('chat.new.mISLec')}</b>{t('chat.new.suffix')} {t('chat.new.end')}
                                </Typography>
                            </Grid>
                        </Box>
                    </Container>
                }
                <Container sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'sticky',
                    bottom: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: '8px',
                    px: 0,
                    background: palette().background.default
                }}>
                    {typing && (
                        <>
                            <Grid
                                container
                                alignItems='center'
                                justifyContent='flex-start'
                                sx={{
                                    fontSize: '0.875rem',
                                    mb: 0.5,
                                    ml: 1
                                }}
                            >
                                {t('chat.message.typing')}
                                <Iconify
                                    icon='svg-spinners:3-dots-fade'
                                    style={{
                                        display: 'flex',
                                        alignSelf: 'flex-end',
                                        fontSize: '12px',
                                        height: '55%',
                                        width: 'auto',
                                        marginLeft: 1,
                                        marginBottom: 1,
                                    }}
                                />
                            </Grid>
                        </>
                    )}
                    <Prompt
                        prompt={prompt}
                        setPrompt={setPrompt}
                        sendMessage={sendMessage}
                    />
                </Container>
            </Container>
        </>
    );
}

export default Chat;
